import { FileList, FilePreview } from '../../File'
import { ScrollSlider as ScrollSliderComponent } from '../../ScrollSlider'
import { Container } from '../Container'

import { SCROLL_SLIDER_MOCK_FILES } from './ScrollSlider.mock'

import * as styles from './ScrollSlider.module.css'

function ScrollSlider() {
  function renderFile(file) {
    return <FilePreview file={file} />
  }

  return (
    <Container label='ScrollSlider'>
      <div className={styles.container}>
        <ScrollSliderComponent itemGap={16} itemWidth={199}>
          <FileList
            className={styles.list}
            files={SCROLL_SLIDER_MOCK_FILES}
            itemClassName={styles.item}
            renderItem={renderFile}
          />
        </ScrollSliderComponent>
      </div>
    </Container>
  )
}

export default ScrollSlider
